import {RqInputAddress} from "./RqInputAddress"
import {RqInputPerson} from "./RqInputPerson";
import {RqInputDocument} from "./RqInputDocument";

export class RqInputInformation {
    person: RqInputPerson
    document: RqInputDocument
    address: RqInputAddress

    constructor(person: RqInputPerson, document: RqInputDocument, address: RqInputAddress) {
        this.person = person;
        this.document = document;
        this.address = address;
    }
}